import {Component, Input, OnInit} from '@angular/core';
import {NextLessonData} from "../../../../types/interfaces";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";
import {TransferLessonsComponent} from "../../modals/transfer-lessons/transfer-lessons.component";
import {ModalController} from "@ionic/angular";

@Component({
    selector: 'app-next-lesson',
    templateUrl: './next-lesson.component.html',
    styleUrls: ['./next-lesson.component.scss'],
})
export class NextLessonComponent implements OnInit {

    @Input() data: NextLessonData;
    @Input() class: string = '';
    @Input() title: string = '';
    @Input() lessonStart: boolean = false;
    @Input() practice: boolean = false;
    @Input() isCurrent: boolean = false;
    @Input() isFuture: boolean = false;
    @Input() isPast: boolean = false;
    @Input() isSchedule: boolean = false;
    @Input() isTransferredLesson: boolean = false;
    @Input() hideButton: boolean = false;

    constructor(public myGcService: MyGreenCountry, private modalCtrl: ModalController,) {
    }

    ngOnInit() {
    }

    openUrl(url: string) {
        this.myGcService.openUrl(url)
    }

    async openTransferModal(action: string) {

        const modal = await this.modalCtrl.create({
            component: TransferLessonsComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                toCancelLessonData: this.data,
            }
        });

        modal.onWillDismiss().then(({ data, role }) => {
            if (role === 'reload') {
                window.location.reload();
            }
        });

        await modal.present();
    }

}
